import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { attritionPredictorSevice } from '../../_services/Analyze/attritionPredictor.service';

export const attritionPredictorAction = {
    attriPreDataAction
}


function attriPreDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        attritionPredictorSevice.getAttrPreData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack() : null
                },
                error => {
                    dispatch(failure(error));
                    callBack != undefined ? callBack() : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_ATTRITION_PREDICTOR } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_ATTRITION_PREDICTOR, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_ATTRITION_PREDICTOR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/attritionPredictor.action.js